export const percentSower = (total, totalCount) => {
    let fractionDigits = 1;

    while(((total/totalCount)*100).toFixed(fractionDigits)*1 === 0) {
        fractionDigits++;
    }
    return ((total/totalCount)*100).toFixed(fractionDigits + 1);
}